import PropTypes from 'prop-types'
import Slot from 'model/appointments/timeSlots/slot'
import { isNil } from 'ramda'
import { ASAP } from 'constants/appointments'

class AsSoonAsPossible extends Slot {
  constructor(init) {
    super(init)
    // console.log('> AsSoonAsPossible constructor -', init)
    if (isNil(init)) return undefined
    this.__typename = init.__typename
  }

  static shape = {
    id: PropTypes.string.isRequired
  }

  get description() {
    return this._description || 'ASAP'
  }

  get display_kind() {
    return this._display_kind || 'ASAP'
  }

  // Calculable
  get isRequested() {
    return (this.__typename || ASAP) === ASAP
  }

  get isAsap() {
    return (this.__typename || ASAP) === ASAP
  }
}

export default AsSoonAsPossible
